import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.css'],
})
export class ToggleSwitchComponent {
  @Input() tabs: TabSwitchModel[] = [
    { id: 0, title: 'Tab 1', isActive: true, danger: false },
    { id: 1, title: 'Tab 2', isActive: false, danger: true },
  ]

  @Output() selected = new EventEmitter<number>()

  toggleTab(index: number) {
    this.tabs = this.tabs.map((tab, i) => ({
      ...tab,
      isActive: i === index,
    }))
    this.selected.emit(index)
  }
}

export interface TabSwitchModel {
  id: number
  title: string
  isActive: boolean
  danger?: boolean
}
